/**
 * API Configuration
 * 
 * 在 Android WebView 中，需要使用絕對 URL 訪問後端
 * 在 Web 瀏覽器中，可以使用相對路徑（通過 Nginx 代理）
 */

// 檢測是否在 Android WebView 中
const isAndroidWebView = () => {
  return typeof (window as any).AndroidWeb3Bridge !== 'undefined' || 
         typeof (window as any).GiGiWallet !== 'undefined';
};

// Select API Base URL based on environment
export const API_BASE_URL = isAndroidWebView()
  ? 'https://devduel.one-chain.io/api'  // Android WebView: 生產服務器
  : '/api';                              // 瀏覽器: 使用 Nginx 代理

/**
 * 構建完整的 API URL
 */
export const getApiUrl = (endpoint: string): string => {
  // 確保 endpoint 以 / 開頭
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  // 如果已經是完整 URL，直接返回
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }
  
  return `${API_BASE_URL}${path}`;
};

/**
 * 統一的 fetch 包裝器
 */
export const apiFetch = async (endpoint: string, options?: RequestInit) => {
  const url = getApiUrl(endpoint);
  console.log(`[API] Fetching: ${url}`);
  
  try {
    // ✅ 先設置默認 headers
    const defaultHeaders: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    
    // ✅ 用戶提供的 headers 優先級更高
    const userHeaders: Record<string, string> = {};
    if (options?.headers) {
      if (options.headers instanceof Headers) {
        options.headers.forEach((value, key) => {
          userHeaders[key] = value;
        });
      } else {
        Object.assign(userHeaders, options.headers);
      }
    }
    
    // ✅ 合併 headers (用戶 headers 會覆蓋默認值)
    const headers: Record<string, string> = {
      ...defaultHeaders,
      ...userHeaders,
    };
    
    // ✅ 創建新的 options 對象，確保不會被攔截器修改
    const fetchOptions: RequestInit = {
      ...options,
      headers,
    };
    
    console.log(`[API] Request headers:`, JSON.stringify(headers));
    console.log(`[API] Request body:`, options?.body ? (typeof options.body === 'string' ? options.body.substring(0, 200) : '[FormData]') : 'none');
    
    const response = await fetch(url, fetchOptions);
    
    return response;
  } catch (error) {
    console.error(`[API] Error fetching ${url}:`, error);
    throw error;
  }
};

export default { API_BASE_URL, getApiUrl, apiFetch };

